module.exports = __webpack_public_path__ + "img/access-messenger.e552d8bf.png";